"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var append_1 = require("./append");
var empty_1 = require("./empty");
exports.setText = function (element, content) {
    empty_1.empty(element);
    append_1.appendText(element, content);
};
